(() => {
  'use strict';

  // Rendered-UI guard only: provider-side sales controls are separately required.
  const BLOCKED_PATH = /\/(?:checkouts?(?:\/|$)|cart\/(?:(?:add|change|update|clear)(?:\.js)?(?:\/|$)|[0-9]+(?::|%3[aA])))/u;
  let actionsConfigured = false;

  const isBlockedPurchaseTarget = (value, base = 'https://shop.invalid') => {
    try {
      const url = new URL(String(value || ''), base);
      return url.origin === new URL(base).origin && BLOCKED_PATH.test(url.pathname);
    } catch {
      return false;
    }
  };

  const announceLock = () => {
    const region = document.querySelector('[data-keysapo-sales-lock-status]');
    if (region) region.textContent = '注文・決済は準備中です。現在は見積相談のみ受け付けています。';
  };

  const blockRenderedPurchaseAction = (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form) return;
    const submitterName = String(event.submitter?.name || '').toLowerCase();
    if (
      submitterName === 'add' ||
      submitterName === 'checkout' ||
      isBlockedPurchaseTarget(form.action, window.location.origin)
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      announceLock();
    }
  };

  const blockRenderedPurchaseLink = (event) => {
    const target = event.target instanceof Element ? event.target.closest('a, button') : null;
    if (!target) return;
    const name = String(target.getAttribute('name') || '').toLowerCase();
    const href = target instanceof HTMLAnchorElement ? target.href : '';
    if (name === 'add' || name === 'checkout' || isBlockedPurchaseTarget(href, window.location.origin)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      announceLock();
    }
  };

  const configureStandardActions = () => {
    if (actionsConfigured) return true;
    const actions = window.Shopify?.actions;
    if (!actions?.updateCart?.configure || !actions?.openCart?.configure) return false;

    actions.updateCart.configure({
      eventTarget: () => document,
      async handler() {
        announceLock();
        return { ok: false, code: 'consultations_only' };
      },
    });
    actions.openCart.configure({
      async handler() {
        window.location.assign('/cart');
      },
    });
    actionsConfigured = true;
    return true;
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { BLOCKED_PATH, isBlockedPurchaseTarget };
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  document.addEventListener('submit', blockRenderedPurchaseAction, true);
  document.addEventListener('click', blockRenderedPurchaseLink, true);

  if (!configureStandardActions()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (configureStandardActions() || attempts >= 40) window.clearInterval(timer);
    }, 250);
  }
})();
